var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('picker',{attrs:{"type":"Template"}}),_c('v-divider',{staticClass:"mt-2 mb-5"}),_c('router-view'),_c('v-sheet',{staticClass:"transparent",attrs:{"height":"20vh"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }